import { gettext } from '@eb/i18n';
import React, { useState } from 'react';
import { CollectionCards } from '../_shared/CollectionCards';
import { LoadMoreCollections } from '../_shared/LoadMoreCollections';
import { useEventCollections } from '../_shared/useEventCollections';
import './EventCollections.scss';
import { Modal } from './Modal';

export const MANY_COLLECTIONS_LIMIT = 9;
export const COLLECTIONS_PAGE_SIZE = 24;
export const LAYOUT_COLUMNS = 3;

export interface Props {
    eventId: string;
}

export const EventCollections: React.FC<Props> = ({ eventId }) => {
    const [opened, setOpened] = useState(false);

    const {
        collections,
        count,
        loadNextPage,
        hasMoreCollections,
        areCollectionsLoading,
    } = useEventCollections(eventId, COLLECTIONS_PAGE_SIZE);

    const countToShow = Math.min(count, MANY_COLLECTIONS_LIMIT);

    if (count === 0) {
        return <></>;
    }

    if (count === 1) {
        const [{ name, url }] = collections;
        return (
            <div>
                {gettext('Part of ')}
                <a href={url} target="_blank" rel="noopener noreferrer">
                    {name}
                </a>
                {gettext(' collection')}
            </div>
        );
    }

    return (
        <div
            className="eds-text-color--ui-600 eds-text-bm eds-l-mar-top-2"
            data-testid="link-to-creator-collections"
        >
            <>
                {gettext('Featured in ')}
                <button
                    className="link-style"
                    onClick={() => {
                        setOpened(true);
                    }}
                >
                    {countToShow}
                    {count > MANY_COLLECTIONS_LIMIT ? '+' : ''}
                    {gettext(' collections')}
                </button>
                <Modal
                    title={gettext('View collections').toString()}
                    visible={opened}
                    onClose={() => setOpened(false)}
                >
                    <CollectionCards
                        collections={collections}
                        columns={LAYOUT_COLUMNS}
                    />
                    <LoadMoreCollections
                        areCollectionsLoading={areCollectionsLoading}
                        loadNextPage={loadNextPage}
                        hasMoreCollections={hasMoreCollections}
                    />
                </Modal>
            </>
        </div>
    );
};
